import { render } from "./AddToCartBasket.vue?vue&type=template&id=6f6376eb"
import script from "./AddToCartBasket.vue?vue&type=script&lang=js"
export * from "./AddToCartBasket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__